import { List } from 'immutable';
import { Component, OnInit } from '@angular/core';
import { BaseEntity, BaseInlineContainer, InlineContainerService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-kurs-dokument-stavka-update-container',
  templateUrl: './kurs-dokument-stavka-update-container.component.html',
//   providers: [
//     InlineContainerService
//   ]
})
export class KursDokumentStavkaUpdateContainer<T extends BaseEntity> extends BaseInlineContainer<T> {

  constructor(inlineContainerService: InlineContainerService<T>,
              activatedRoute: ActivatedRoute,
              userService: UserService){
super(inlineContainerService, activatedRoute, userService);
}

 

}
